import { render, staticRenderFns } from "./EventItemUsersView.vue?vue&type=template&id=1f1faf15&"
import script from "./EventItemUsersView.vue?vue&type=script&lang=js&"
export * from "./EventItemUsersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Users/devteam/projects/dominion-conference-app/ConferenceAdmin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports